import type { RouteRecordRaw } from 'vue-router'
import ScheduledMessage from '@/data/models/domain/scheduled/ScheduledMessage'
import ScheduledShortMessage from '@/data/models/domain/scheduled/ScheduledShortMessage'
import ScheduledNotSentMessage from '@/data/models/domain/scheduled/ScheduledNotSentMessage'
import { AppModule } from '@/config/types'
import type { ResolverConfig } from '@/services/types'
import { ScheduledRoutes } from '@/routes/user/scheduled/types'
import { scheduledUpcomingRoutes } from '@/routes/user/scheduled/upcoming'
import { scheduledPausedRoutes } from '@/routes/user/scheduled/paused'
import { scheduledNotSentRoutes } from '@/routes/user/scheduled/notSent'
import { scheduledCompletedRoutes } from '@/routes/user/scheduled/completed'
import { scheduledCalenderRoutes } from '@/routes/user/scheduled/calendar'
import { scheduledEditRoutes } from '@/routes/user/scheduled/edit'
import { scheduledEditEmailRoutes } from '@/routes/user/scheduled/editEmail'
import { scheduledDetailsRoutes } from '@/routes/user/scheduled/details'
import ScheduledEmail from '@/data/models/domain/ScheduledEmail'
import type { ComponentProps } from '@/composition/types'
import type ScheduledDetailsEmail from '@/components/views/scheduled/ScheduledDetailsEmail.vue'
import ScheduledMenu from '@/components/domain/scheduled/ScheduledMenu.vue'

export const scheduledFacetResolver: ResolverConfig = {
  service: 'FacetResolver',
  params: {
    model: ScheduledMessage,
    subscriptionModels: [ScheduledShortMessage, ScheduledMessage, ScheduledNotSentMessage, ScheduledEmail],
  },
}

export const getScheduledRoutes = (): RouteRecordRaw[] => [
  {
    name: ScheduledRoutes.scheduled,
    path: 'scheduled',
    meta: {
      tags: ['USER_TOP_MENU'],
      menu: ScheduledMenu,
      permission: 'scheduled',
      modules: [AppModule.Scheduled, AppModule.Compose, AppModule.ComposeEmail, AppModule.Labels],
    },
    redirect: { name: ScheduledRoutes.scheduledIndex },
    children: [
      {
        name: ScheduledRoutes.scheduledIndex,
        path: '',
        meta: {
          resolvers: [scheduledFacetResolver],
        },
        redirect: { name: ScheduledRoutes.upcoming },
        component: () => import('@/components/views/scheduled/Scheduled.vue'),
        children: [
          scheduledUpcomingRoutes,
          scheduledPausedRoutes,
          scheduledNotSentRoutes,
          scheduledCompletedRoutes,
          scheduledCalenderRoutes,
          scheduledDetailsRoutes,
          {
            name: ScheduledRoutes.detailsEmail,
            path: 'details-email/:messageId',
            props: (route) => {
              return {
                messageId: route.params.messageId as string,
              } satisfies ComponentProps<typeof ScheduledDetailsEmail>
            },
            meta: {
              tabTitle: 'pageTabTitle.user.scheduled.detailsEmail',
              resolverComponent: () => import('@/components/domain/scheduled/ScheduledEmailDetailsResolver.vue'),
              redirectToIfNotFound: { name: ScheduledRoutes.upcomingOverviewEmail },
              titler: {
                service: 'RouteTitlerService',
              },
              resolvers: [
                {
                  service: 'ScheduledEmailDetailsResolverService',
                },
              ],
              modules: [
                AppModule.ScheduledEmail,
                AppModule.ContactList,
                AppModule.SentSmsBase,
                AppModule.RecentRecipient,
                AppModule.CampaignsSenders,
                AppModule.Recipient,
              ],
            },
            component: () => import('@/components/views/scheduled/ScheduledDetailsEmail.vue'),
          },
          scheduledEditRoutes,
        ],
      },
    ],
  },
  scheduledEditEmailRoutes,
]
